const pgcetmbaQuantitativeAnalysis = [
  {
    id: 41,
    question: "Which component of the CPU temporarily holds data and instructions being processed?",
    options: ["A. Control Unit", "B. Arithmetic Logic Unit", "C. Register", "D. Cache Controller"],
    answer: "C"
  },
  {
    id: 42,
    question: "Which type of memory loses its content when power is switched off?",
    options: ["A. ROM", "B. RAM", "C. Flash Memory", "D. Magnetic Tape"],
    answer: "B"
  },
  {
    id: 43,
    question: "The decimal equivalent of the hexadecimal number (3F)16 is:",
    options: ["A. 61", "B. 62", "C. 63", "D. 64"],
    answer: "C"
  },
  {
    id: 44,
    question: "Which of the following network devices operates by connecting two different networks using different protocols?",
    options: ["A. Hub", "B. Switch", "C. Bridge", "D. Gateway"],
    answer: "D"
  },
  {
    id: 45,
    question: "Which of the following is an advantage of a Database Management System (DBMS)?",
    options: [
      "A. Increased data redundancy",
      "B. Reduced data security",
      "C. Reduced data redundancy",
      "D. Increased data inconsistency"
    ],
    answer: "C"
  },
  {
    id: 46,
    question: "Which generation of programming languages does SQL (Structured Query Language) belong to?",
    options: ["A. Second generation", "B. Third generation", "C. Fourth generation", "D. Fifth generation"],
    answer: "C"
  },
  {
    id: 47,
    question: "In the OSI model, which layer is primarily responsible for establishing, managing, and terminating sessions between applications?",
    options: ["A. Transport Layer", "B. Session Layer", "C. Presentation Layer", "D. Application Layer"],
    answer: "B"
  },
  {
    id: 48,
    question: "Which of the following best describes 'cache memory'?",
    options: [
      "A. Permanent, non-volatile storage",
      "B. High-speed memory that stores frequently accessed data close to the CPU",
      "C. Backup storage on an external drive",
      "D. Memory used only for booting the operating system"
    ],
    answer: "B"
  },
  {
    id: 49,
    question: "One's complement of the binary number 11010 is:",
    options: ["A. 00101", "B. 00100", "C. 00110", "D. 01101"],
    answer: "A"
  },
  {
    id: 50,
    question: "Which of the following operating systems is primarily used for mobile devices?",
    options: ["A. Windows Server", "B. Android", "C. Unix", "D. MS-DOS"],
    answer: "B"
  },
  {
    id: 51,
    question: "The two's complement of a binary number is obtained by adding _____ to its one's complement.",
    options: ["A. 0", "B. 1", "C. 10", "D. 11"],
    answer: "B"
  },
  {
    id: 52,
    question: "Which of the following is NOT typically a function of the Arithmetic Logic Unit (ALU)?",
    options: [
      "A. Addition and subtraction",
      "B. Logical AND, OR and NOT operations",
      "C. Comparison of two values",
      "D. Fetching instructions from memory"
    ],
    answer: "D"
  },
  {
    id: 53,
    question: "Which SQL command is used to permanently remove a table's structure and all its data?",
    options: ["A. DELETE", "B. TRUNCATE", "C. DROP", "D. REMOVE"],
    answer: "C"
  },
  {
    id: 54,
    question: "The base of the octal number system is:",
    options: ["A. 2", "B. 8", "C. 10", "D. 16"],
    answer: "B"
  },
  {
    id: 55,
    question: "Which of the following best describes 'phishing' in the context of cybersecurity?",
    options: [
      "A. A technique to speed up internet browsing",
      "B. A fraudulent attempt to obtain sensitive information by disguising as a trustworthy source",
      "C. A method of compressing large files",
      "D. A protocol used for secure email transmission"
    ],
    answer: "B"
  },
  {
    id: 56,
    question: "In a relational database, a key that uniquely identifies each record in a table is called a:",
    options: ["A. Foreign Key", "B. Candidate Key", "C. Primary Key", "D. Composite Key"],
    answer: "C"
  },
  {
    id: 57,
    question: "Which of the following storage devices offers the fastest data access speed?",
    options: ["A. Hard Disk Drive (HDD)", "B. Solid State Drive (SSD)", "C. Magnetic Tape", "D. CD-ROM"],
    answer: "B"
  },
  {
    id: 58,
    question: "The default port number used for sending email via SMTP is:",
    options: ["A. 21", "B. 25", "C. 80", "D. 443"],
    answer: "B"
  },
  {
    id: 59,
    question: "Which normal form in database design eliminates partial dependency on a composite primary key?",
    options: ["A. 1NF", "B. 2NF", "C. 3NF", "D. BCNF"],
    answer: "B"
  },
  {
    id: 60,
    question: "Which of the following best defines 'cloud computing'?",
    options: [
      "A. Storing data only on local hard drives",
      "B. Delivery of computing services such as storage and processing over the internet",
      "C. A method of encrypting data before transmission",
      "D. A type of computer virus"
    ],
    answer: "B"
  }

];
 
export default pgcetmbaQuantitativeAnalysis;